<!--
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-26 10:50:05
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-06-11 12:00:54
 * @FilePath: /designcenter/src/layout/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="app-wrapper">
    <!-- 顶部导航 -->
    <Navbar />
    <!-- 异常状态页面 -->
    <div v-if="showErrorState" class="main-container error-state-container">
      <div class="error-state-content">
        <img :src="noAuthImage" alt="No Access" class="error-image" />
        <p class="error-title">{{ errorTitle }}</p>
        <p class="error-description">{{ errorDescription }}</p>
        <span class="backToProject" @click="toProjectManage">Back to Project Management</span>
      </div>
    </div>
    <!-- 正常内容 -->
    <div v-else-if="route.meta?.layout !== 'manual'" class="main-container">
      <!-- 左侧菜单 -->
      <Sidebar class="sidebar-container" v-if="!['TemplateConfig'].includes(route.name)" />
      <!-- 主要内容区域 -->
      <div class="app-main">
        <router-view />
      </div>
    </div>
    <!-- 操作手册布局 -->
    <router-view v-else />
  </div>
  <!-- 公共页面（如操作手册）无需登录，不渲染这些数据型弹窗，避免触发鉴权类接口请求 -->
  <template v-if="!route.meta?.public">
    <AddProjectPopup />
    <SelectTemplate />
    <ExportProjectPopup />
    <SelectProject />
  </template>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, nextTick, defineAsyncComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useErrorState } from '@/composables/useErrorState'
import noAuthImage from '@/assets/images/noAuth.png'
import { useProjectStore } from '@/store/project'

// 同步加载关键组件
import Navbar from './components/Navbar.vue'
import Sidebar from './components/Sidebar.vue'

// 异步加载非关键弹窗组件
const AddProjectPopup = defineAsyncComponent(() => import('@/components/AddProjectPopup/AddProjectPopup.vue'))
const SelectTemplate = defineAsyncComponent(() => import('@/components/SelectTemplate/SelectTemplate.vue'))
const ExportProjectPopup = defineAsyncComponent(() => import('@/components/ExportProjectPopup/ExportProjectPopup.vue'))
const SelectProject = defineAsyncComponent(() => import('@/components/SelectProject/SelectProject.vue'))

const route = useRoute()
const router = useRouter()
const projectStore = useProjectStore()

// 使用错误状态 composable
const { hideError, showErrorState, errorTitle, errorDescription } = useErrorState()
// 设置CSS变量
const setAppMainVars = () => {
  const appMain = document.querySelector('.app-main')
  if (appMain) {
    const rect = appMain.getBoundingClientRect()
    document.documentElement.style.setProperty('--app-main-height', `${rect.height}px`)
    document.documentElement.style.setProperty('--app-main-top', `${rect.top}px`)
  }
}

const toProjectManage = async () => {
  // 先清除错误状态
  hideError()
  // 标记正在离开当前页面，阻止 watch 执行
  projectStore.setProjectSwitching(true)
  await nextTick()

  router.replace({ path: '/project' })
}

// 监听窗口大小变化
const handleResize = () => {
  setAppMainVars()
}

onMounted(() => {
  setAppMainVars()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  .main-container {
    width: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    .app-main {
      flex: 1 1 auto;
      height: 100%;
      overflow: hidden;
      background: #fafafa;
    }
  }

  // 异常状态容器
  .error-state-container {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    background: #fafafa;
  }

  .error-state-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 40px 40px 40px;
    margin-top: 332px;

    .error-image {
      height: 80px;
      width: auto;
      margin-bottom: 12px;
    }

    .error-title {
      font-size: 16px;
      font-weight: 600;
      color: #19191a;
      line-height: 28px;
      margin: 0 0 4px 0;
    }

    .error-description {
      font-size: 12px;
      color: #707070;
      line-height: 22px;
      margin: 0;
      max-width: 800px;
    }
  }
}

.backToProject {
  background: #c00000;
  border-radius: 4px;
  cursor: pointer;
  padding: 0 16px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #fff;
  margin-top: 20px;
}
</style>
